module.exports = __webpack_public_path__ + "img/8.0df42de3.png";